let activeFetchController = null;
let fetchRequestId = 0;

function initCollectionHoverSwatches() {
  const cards = document.querySelectorAll('product-card');

  cards.forEach((card) => {
    const mainImg = card.querySelector('.product-card-img');
    if (!mainImg) return;

    const swatches = card.querySelectorAll('[data-name="swatch-option"]');

    swatches.forEach((swatch) => {
      const input = swatch.querySelector('input');

      swatch.addEventListener('mouseenter', (event) => {
        event.stopPropagation();
        event.stopImmediatePropagation();

        const variantImage = input?.getAttribute('data-variant-image');
        if (variantImage) {
          mainImg.src = variantImage;
          mainImg.srcset = `${variantImage} 300w, ${variantImage} 400w, ${variantImage} 550w, ${variantImage} 750w, ${variantImage} 1100w`;
        }
      });

      swatch.addEventListener('mouseleave', (event) => {
        event.stopPropagation();
        event.stopImmediatePropagation();

        const originalImg = mainImg.getAttribute('data-original-src');
        if (originalImg) {
          mainImg.src = originalImg;
        }
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const frameCountEl        = document.getElementById("active-filters-count");
  const collectionHandle    = window.shopData.collectionHandle;
  const sortBySelect        = document.getElementById("sort-by");
  const filterCheckboxes    = document.querySelectorAll('[data-armada-selector="custom_filter_checkbox"]');
  const filterLabels        = document.querySelectorAll('[data-armada-selector="custom_filter_checkbox-label"]');
  const collectionContainer = document.getElementById("custom-collection-layout");
  const filterSidebar       = document.getElementById("custom-main-collection-left");
  const mobileLayout        = window.matchMedia("(max-width: 768px)");
  let pillClickDebounce = null;

  frameCountEl.innerHTML = "| " + frameCountEl.dataset.total + " Frames  ";

  // ── helpers ────────────────────────────────────────────────────────────────

  function encodeUriWithPlus(str) {
    return encodeURIComponent(str).replace(/%20/g, "+");
  }

  function scrollToGridTop() {
    collectionContainer.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  const removeFilterCheckboxes = (checkboxList, targetValue, removeAll) => {
    if (removeAll) {
      checkboxList.forEach((cb) => {
        if (cb.checked) cb.checked = false;
      });
    } else {
      checkboxList.forEach((cb) => {
        if (cb.value === targetValue) cb.checked = false; // always uncheck, never toggle
      });
    }
  };

  function getActiveFiltersUrl() {
    const baseUrl      = window.location.href.split('?')[0];
    const sort_by      = new URLSearchParams(window.location.search).get("sort_by");
    const activeParams = [];

    document.querySelectorAll('[data-armada-selector="custom_filter_checkbox"]').forEach((cb) => {
      if (cb.checked) activeParams.push(cb.name + "=" + encodeUriWithPlus(cb.value));
    });

    if (sort_by) activeParams.push("sort_by=" + sort_by);

    let finalUrl = activeParams.length ? baseUrl + "?" + activeParams.join('&') : baseUrl;

    // Shopify expects filter params to start with "filter"
    if (activeParams.length > 0 && !finalUrl.includes('?filter')) {
      const queryPart = finalUrl.split('?')[1] || '';
      if (!queryPart.startsWith('filter')) {
        finalUrl = finalUrl.replace('?', '?filter');
      }
    }

    // Clean up any doubled separators
    finalUrl = finalUrl.replace(/[?&]{2,}/g, (m) => m[0]);
    if (finalUrl.endsWith('?') || finalUrl.endsWith('&')) finalUrl = finalUrl.slice(0, -1);

    return finalUrl;
  }

  // ── mobile preview count ───────────────────────────────────────────────────

  let previewFetchController = null;

  function fetchMobilePreviewCount(url) {
    if (previewFetchController) previewFetchController.abort();
    previewFetchController = new AbortController();

    const applyBtn  = document.getElementById('mobile-filter-apply');
    const countSpan = document.getElementById('mobile-filter-frame-count');
    if (!applyBtn || !countSpan) return;

    applyBtn.disabled     = true;
    countSpan.textContent = '...';

    fetch(url, { signal: previewFetchController.signal })
      .then(res => res.text())
      .then(data => {
        const tmp     = document.createElement('div');
        tmp.innerHTML = data;
        const countEl = tmp.querySelector('[data-count]');
        if (countEl) countSpan.textContent = countEl.dataset.count;
        applyBtn.disabled = false;
      })
      .catch(err => {
        if (err.name !== 'AbortError') console.error('Preview fetch error:', err);
      });
  }

  // ── main fetch ─────────────────────────────────────────────────────────────

  function fetchData(url, onComplete) {
    if (activeFetchController) activeFetchController.abort();

    activeFetchController  = new AbortController();
    const currentRequestId = ++fetchRequestId;

    custom_loader.classList.remove("hidden");

    fetch(url, { signal: activeFetchController.signal })
      .then((response) => response.text())
      .then((data) => {

        console.log(currentRequestId)
        console.log(fetchRequestId)
        console.log(currentRequestId !== fetchRequestId)

        if (currentRequestId !== fetchRequestId) return;

        const parsedPage = document.createElement("div");
        parsedPage.innerHTML = data;

        const countEl              = parsedPage.querySelector('[data-count]');
        const newGridHTML          = parsedPage.querySelector('[data-armada-selector="collection-grid-main"]')?.innerHTML;
        const newActiveFiltersHTML = parsedPage.querySelector('[data-armada-selector="active-filters"]')?.innerHTML;

        if (!newGridHTML || !newActiveFiltersHTML) return;

        document.querySelector('[data-armada-selector="collection-grid-main"]').innerHTML = newGridHTML;
        document.querySelector('[data-armada-selector="active-filters"]').innerHTML       = newActiveFiltersHTML;

        initCollectionHoverSwatches();
        document.dispatchEvent(new CustomEvent('collectionGridUpdated'));

        if (mobileLayout.matches) {
          const gridCards  = Array.from(document.getElementsByClassName("grid-product-card"));
          const promoCards = Array.from(document.getElementsByClassName("new-promo-card-container"));

          if (localStorage.getItem("layout") == "list") {
            setListLayoutView(gridCards, promoCards);
          } else {
            setGridLayoutView(gridCards, promoCards);
          }
        }

        custom_loader = document.querySelector("#custom_loader");
        custom_loader.classList.add("hidden");

        if (typeof onComplete === "function") {
          setTimeout(() => onComplete(), 0);
        }

        history.replaceState(null, null, url);

        frameCountEl.innerHTML = "| " + countEl.dataset.count + " Frames ";

        addClearFiltersOption();
        scrollToGridTop();
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => {
        if (currentRequestId === fetchRequestId) {
          custom_loader.classList.add("hidden");
        }
      });
  }

  function addClearFiltersOption() {
    if (document.querySelectorAll('[data-armada-selector="active-filters__remove-filter"]').length > 0) {
      const clearBtn = document.createElement("u");
      clearBtn.setAttribute("id", "clear-filters");
      clearBtn.innerHTML = "Clear Filters";
      frameCountEl.appendChild(clearBtn);

      clearBtn.addEventListener("click", () => {
        removeFilterCheckboxes(filterCheckboxes, null, true); // uncheck all first
        fetchData(collectionHandle); // no callback
      });
    }
  }

  // ── active filter pill removal ─────────────────────────────────────────────

  document.addEventListener("click", (e) => {
    if (e.target.matches('[data-armada-selector="active-filters__remove-filter"]')) {
      const pillValue = e.target.getAttribute("data-value");

      removeFilterCheckboxes(filterCheckboxes, pillValue); // always uncheck

      clearTimeout(pillClickDebounce);
      pillClickDebounce = setTimeout(() => {
        fetchData(getActiveFiltersUrl());
      }, 50);
    }
  });
  // ── label clicks & checkbox changes ───────────────────────────────────────

  filterCheckboxes.forEach((cb) =>
    cb.addEventListener("change", () => {
      if (mobileLayout.matches) {
        fetchMobilePreviewCount(getActiveFiltersUrl());
      } else {
        fetchData(getActiveFiltersUrl());
      }
    })
  );

  // ── sort by ────────────────────────────────────────────────────────────────

  sortBySelect.addEventListener("change", (e) => {
    let sortUrl;
    const currentUrl = window.location.href;

    custom_loader = document.querySelector("#custom_loader");
    custom_loader.classList.remove("hidden");

    if (currentUrl.includes("filter")) {
      if (currentUrl.includes("sort_by")) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.delete("sort_by");
        if (e.target.value != "best-selling") searchParams.append("sort_by", e.target.value);
        sortUrl = window.location.pathname + "?" + searchParams.toString();
      } else {
        sortUrl = e.target.value == "best-selling" ? currentUrl : currentUrl + "&sort_by=" + e.target.value;
      }
    } else {
      sortUrl = e.target.value == "best-selling"
        ? "/collections/" + collectionHandle
        : "/collections/" + collectionHandle + "?sort_by=" + e.target.value;
    }

    fetch(sortUrl)
      .then((res) => res.text())
      .then((data) => {
        custom_loader.classList.add("hidden");
        const parsedPage  = document.createElement("div");
        parsedPage.innerHTML = data;
        const newGridHTML = parsedPage.querySelector('[data-armada-selector="collection-grid-main"]')?.innerHTML;
        if (newGridHTML) {
          document.querySelector('[data-armada-selector="collection-grid-main"]').innerHTML = newGridHTML;
          initCollectionHoverSwatches();
        }
        history.replaceState(null, null, sortUrl);
      });
  });

  // ── sticky sidebar on scroll ───────────────────────────────────────────────

  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  document.addEventListener("scroll", () => {
    const scrollTop      = window.pageYOffset || document.documentElement.scrollTop;
    const viewportHeight = window.innerHeight;

    if (filterSidebar.offsetHeight > viewportHeight) {
      const currentTop = parseFloat(getComputedStyle(filterSidebar).top);
      const maxTop     = viewportHeight - filterSidebar.offsetHeight;

      filterSidebar.style.top = scrollTop > lastScrollTop
        ? Math.max(maxTop, currentTop - (scrollTop - lastScrollTop)) + "px"
        : Math.min(120, currentTop + (lastScrollTop - scrollTop)) + "px";
    } else {
      filterSidebar.style.top = "120px";
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  });

  // ── mobile apply / reset ───────────────────────────────────────────────────

  const mobileApplyBtn = document.getElementById('mobile-filter-apply');
  const mobileResetBtn = document.getElementById('mobile-filter-reset');

  if (mobileApplyBtn) {
    mobileApplyBtn.addEventListener('click', () => {
      fetchData(getActiveFiltersUrl());
      if (mobileFilterDrawer) {
        mobileFilterDrawer.setAttribute('aria-hidden', 'true');
        if (pageOverlay) pageOverlay.style.visibility = 'hidden';
        document.body.style.removeProperty('overflow');
      }
    });
  }

  if (mobileResetBtn) {
    mobileResetBtn.addEventListener('click', () => {
      document.querySelectorAll('[data-armada-selector="custom_filter_checkbox"]').forEach(cb => { cb.checked = false; });
      const countSpan = document.getElementById('mobile-filter-frame-count');
      if (countSpan) countSpan.textContent = frameCountEl.dataset.total ?? '';
      if (mobileApplyBtn) mobileApplyBtn.disabled = false;
    });
  }

  // ── mobile drawer open / close ─────────────────────────────────────────────

  const openDrawerBtn      = document.querySelector('[data-armada-selector="filter-by-mobile-btn"]');
  const closeDrawerBtn     = document.querySelector('[data-action="close-mobile-filter-drawer"]');
  const mobileFilterDrawer = document.querySelector('[data-armada-selector="filter-mobile-drawer-selector"]');
  const pageOverlay        = document.getElementById("PageOverlay");

  const closeMobileDrawer = (e) => {
    e.preventDefault();
    pageOverlay.style.visibility = "hidden";
    mobileFilterDrawer.setAttribute("aria-hidden", "true");
    document.body.style.removeProperty('overflow');
  };

  const openMobileDrawer = () => {
    pageOverlay.style.zIndex     = 150;
    pageOverlay.style.visibility = "visible";
    mobileFilterDrawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  };

  openDrawerBtn.addEventListener("click", openMobileDrawer);
  closeDrawerBtn.addEventListener("click", (e) => closeMobileDrawer(e));
  pageOverlay.addEventListener("click", (e) => closeMobileDrawer(e));
});